import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { PopupService } from "src/app/shared/popup/popup.service";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-sidebar-table-list",
  templateUrl: "./sidebar-table-list.component.html",
  styleUrls: ["./sidebar-table-list.component.scss"],
})
export class SidebarTableListComponent implements OnInit {
  // ***********************************
  // TODO: this component is not finished yet, or even tested due to list items are not being passed
  // ***********************************

  @Input() id: number;
  @Input() sidebarName: string;
  @Input() list: any;
  @Input() sidebarHeaderTitle: string;
  @Output() submit: EventEmitter<string> = new EventEmitter();
  keyword: string = null;

  isBtnLoading: any;
  translationModulesEnum = TranslationModuleEnum;

  constructor(
    private popupService: PopupService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    // this.initForm();
  }



  close() {
    this.popupService.close();
  }

  // onSubmit() {
  //   if (this.form.invalid) {
  //     return;
  //   }
  //   this.isBtnLoading = true;

  //   this.submit.emit(this.form.value.reason);
  //   this.close();
  // }
}
